import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import Button from "components/CustomButtons/Button.js";

import cardsStyle from "assets/jss/material-kit-pro-react/views/componentsSections/sectionCards.js";
import {
	getCategoryImageURI,
	getLinkToDetailsForOffering,
	mapDayEnumsToAbbrev,
	stripHtml,
} from "../../utils/Utils";

const style = {
	...cardsStyle,
	wrapperBackground: {
		...cardsStyle.wrapperBackground,
		"&:after": {
			...cardsStyle.wrapperBackground["&:after"],
			backgroundColor: "rgba(0, 0, 0, 0)",
		},
	},
	cardFooter: {
		marginLeft: "auto",
		marginRight: "auto",
		marginTop: "auto",
	},
	clamp6Lines: {
		display: "-webkit-box",
		WebkitBoxOrient: "vertical",
		WebkitLineClamp: 6,
		overflow: "hidden",
	},
	clamp1Lines: {
		display: "-webkit-box",
		WebkitBoxOrient: "vertical",
		WebkitLineClamp: 1,
		overflow: "hidden",
	},
	daysAndTarget: {
		display: "flex",
		alignSelf: "center",
	},
	cardTitleWhite: {
		...cardsStyle.cardTitleWhite,
		textShadow: "2px 2px 4px #000000",
	},
};

const useStyles = makeStyles(style);

const OfferingCard = ({ offering }) => {
	const [backgroundImage, setBackgroundImage] = useState();

	React.useEffect(() => {
		addStylesForRotatingCards();
		return function cleanup() {};
	});
	const addStylesForRotatingCards = () => {
		const rotatingCards = document.getElementsByClassName(classes.cardRotate);
		for (let i = 0; i < rotatingCards.length; i++) {
			const rotatingCard = rotatingCards[i];
			const cardFront = rotatingCard.getElementsByClassName(classes.front)[0];
			const cardBack = rotatingCard.getElementsByClassName(classes.back)[0];
			cardFront.style.height = "unset";
			cardFront.style.width = "unset";
			cardBack.style.height = "unset";
			cardBack.style.width = "unset";
			const rotatingWrapper = rotatingCard.parentElement;
			const cardWidth = rotatingCard.parentElement.offsetWidth;
			const cardHeight = rotatingCard.children[0].children[0].offsetHeight;
			rotatingWrapper.style.height = cardHeight + "px";
			rotatingWrapper.style["margin-bottom"] = 30 + "px";
			cardFront.style.height = "unset";
			cardFront.style.width = "unset";
			cardBack.style.height = "unset";
			cardBack.style.width = "unset";
			cardFront.style.height = cardHeight + 35 + "px";
			cardFront.style.width = cardWidth + "px";
			cardBack.style.height = cardHeight + 35 + "px";
			cardBack.style.width = cardWidth + "px";
		}
	};
	const classes = useStyles();
	const targetGroup = offering.targetGroup;

	useEffect(() => {
		if (offering.image) {
			setBackgroundImage(`url(${offering.image})`);
		} else {
			setBackgroundImage(`url(${getCategoryImageURI(offering.category)})`);
		}
	}, [offering.image]);

	return (
		<div className={classes.rotatingCardContainer}>
			<Card className={classes.cardRotate}>
				<div
					className={`${classes.front} ${classes.wrapperBackground}`}
					style={{
						backgroundImage: backgroundImage,
					}}
				>
					<CardBody background className={classes.cardBodyRotate}>
						<h3 className={classes.cardTitleWhite}>{offering.title}</h3>
					</CardBody>
				</div>
				<div className={`${classes.back} ${classes.wrapperBackground}`}>
					<CardBody background className={classes.cardBodyRotate}>
						<div className={classes.daysAndTarget}>
							{offering.schedules && (
								<p className={classes.clamp1Lines}>
									{offering.schedules
										.map(
											(schedule) =>
												`${mapDayEnumsToAbbrev(schedule.day)}: ${
													schedule.from
												}`,
										)
										.join(", ")}
									{", "}Alter: {targetGroup.from}-{targetGroup.to}
								</p>
							)}
						</div>
						<p className={classes.clamp6Lines}>{offering.description}</p>
						<div className={classes.cardFooter}>
							<Link to={getLinkToDetailsForOffering(offering)}>
								<Button color="primary" target="_blank">
									DETAILS
								</Button>
							</Link>
						</div>
					</CardBody>
				</div>
			</Card>
		</div>
	);
};

OfferingCard.propTypes = {
	offering: PropTypes.object,
};

export default OfferingCard;
